export const INVALID_MAJOR_ID = 'invalid-major';
